let elements = {
  //pick: 3,
  blockCheck: true,
  permanent: true,
  mainImage: {
    imagePath: 'games/page035_game0/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page035_game0/audio/false.mp3',
    // positive: 'games/page035_game0/audio/empty_true.mp3',
    click: 'games/page035_game0/audio/click.mp3',
    icon: {
      on: 'games/page035_game0/img/audioOn.png',
      off: 'games/page035_game0/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 20,
    height: 20,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 161,
    height: 94,
  },
  layoutItems: [
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
    { pos: { x: 0, y: 0 } },
  ],
  layoutCorrectItems: [
    { pos: { x: 426, y: -5 } },
    { pos: { x: 426, y: 93 } },
    //
    { pos: { x: 426, y: 191 } },
    //
    { pos: { x: 426, y: 290 } },
    //aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
    { pos: { x: 1078, y: -5 } },
    { pos: { x: 1078, y: 93 } },
    //
    { pos: { x: 1078, y: 191 } },
    //
    { pos: { x: 1078, y: 290 } },
    //aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
    { pos: { x: 241, y: 477 } },
    { pos: { x: 241, y: 575 } },
    //
    { pos: { x: 241, y: 673 } },
    //
    { pos: { x: 241, y: 772 } },
    //aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa
    { pos: { x: 925, y: 477 } },
    { pos: { x: 925, y: 575 } },
    //
    { pos: { x: 925, y: 673 } },
    //
    { pos: { x: 925, y: 772 } },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: true,
  pick: 0,
  falseStatus: true,
  groups: [
    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/43_banana.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/banan.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/bananok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page035_game0/img/mar.webp',
            },
            width: 161,
            height: 94,
            incorrectItems: {
              images: [
                {
                  src: 'games/page035_game0/img/marwr.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/46_lemon.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/lemon.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/lemonok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/45_cherry.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/che.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/cheok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //GRUSZA TOMATO PAPRYK SMUTQ

    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/44_pear.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/grusz.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/gruszok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/49_tomato.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/pom.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/pomok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page035_game0/img/che.webp',
            },
            width: 161,
            height: 94,
            incorrectItems: {
              images: [
                {
                  src: 'games/page035_game0/img/chewr.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/47_pepper.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/papryk.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/paprykok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //NANAB PAPRYK SMUTQ MARCHEW

    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/48_carrot.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/mar.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/marok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/47_pepper.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/papryk.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/paprykok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/43_banana.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/banan.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/bananok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page035_game0/img/lemon.webp',
            },
            width: 161,
            height: 94,
            incorrectItems: {
              images: [
                {
                  src: 'games/page035_game0/img/lemonwr.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    //WISNIA GRUSZKA CYTRYNA

    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/45_cherry.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/che.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/cheok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/44_pear.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/grusz.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/gruszok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page035_game0/img/banan.webp',
            },
            width: 161,
            height: 94,
            incorrectItems: {
              images: [
                {
                  src: 'games/page035_game0/img/bananwr.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page035_game0/audio/46_lemon.mp3',
          correct: {
            image: {
              src: 'games/page035_game0/img/lemon.webp',
            },
            width: 161,
            height: 94,
            correctItems: {
              images: [
                {
                  src: 'games/page035_game0/img/lemonok.webp',
                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 161,
                  height: 94,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  mbStaticAudioItemData: [
    {
      src: 'games/page035_game0/audio/46_lemon.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 317,
        x: 875,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/46_lemon.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 728,
        x: 1385,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/43_banana.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 107,
        x: 725,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/43_banana.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 607,
        x: 495,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/44_pear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 507,
        x: 1275,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/44_pear.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 287,
        x: 1275,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/45_cherry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 117,
        x: 915,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/45_cherry.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 647,
        x: 1135,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/47_pepper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 287,
        x: 1615,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/47_pepper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 467,
        x: 695,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/48_carrot.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 787,
        x: 695,
      },
      unit: 'px',
    },
    {
      src: 'games/page035_game0/audio/49_tomato.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page035_game0/img/audioOn.png', iconOff: 'games/page035_game0/img/audioOff.png' },
        fill: 'none',
      },
      width: '46px',
      height: '46px',
      pos: {
        y: 17,
        x: 1595,
      },
      unit: 'px',
    },
  ],
};

export default elements;
